"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const DownloadButton = dynamic(() => import("./DownloadButton").then((mod) => mod.DownloadButton));

export const downloadButtonInputs = [
  {
    name: "link",
    type: "url",
    required: true,
  },
  {
    name: "text",
    type: "string",
  },
] as const satisfies Inputs;

export const DownloadButtonComponent: RegisteredComponent = {
  name: "DownloadButton",
  component: DownloadButton,
  inputs: downloadButtonInputs,
};
